var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"toaster"}},[_c('transition-group',{attrs:{"name":"toasts-list","tag":"ul"}},_vm._l((_vm.toasts),function(toast){return _c('li',{key:toast.id,staticClass:"toasts-list-item"},[_c('toast-message',{attrs:{"toast":toast},on:{"remove":_vm.remove}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }